/* import __COLOCATED_TEMPLATE__ from './index.hbs.js'; */
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { get } from "@ember/object";
import ScaleSurveyEditionFormComponent from "core/components/abstract/scale-survey-edition-form";
import { Payload } from "core/components/forc/abstract/journal-event-based-component";
import BdiIiDeclaredJournalEvent from "core/models/bdi-ii-declared-journal-event";
import bdiIiScoreDescription from "core/utils/bdi-ii-score-description";
export default class BdiIiEditionFormComponent extends ScaleSurveyEditionFormComponent {
  get numberOfItems() {
    return 21;
  }
  get maximalScore() {
    return 63;
  }
  _computeScore(payload) {
    const number = this.questionIds.reduce((total, index) => total + parseInt(get(payload, index)), 0);
    return {
      number,
      description: bdiIiScoreDescription(number)
    };
  }
}
_defineProperty(BdiIiEditionFormComponent, "forcDisplayName", "Questionnaire d'évaluation de la dépression - BDI-II");
_defineProperty(BdiIiEditionFormComponent, "fullComponentId", "scale-surveys/bdi-ii-edition-form");
_defineProperty(BdiIiEditionFormComponent, "journalEventClass", BdiIiDeclaredJournalEvent);